export function getCookie(key: string) {
    const val = (
        ("; " + document.cookie).split("; " + key + "=")[1] || ""
    ).split(";")[0];
    return typeof val !== "undefined" ? decodeURIComponent(val) : undefined;
}

export function setCookie(
    key: string,
    value: string,
    duration: number,
    unit: "days" | "minutes" = "days",
) {
    const expires = new Date();

    if (unit === "minutes") {
        expires.setTime(expires.getTime() + duration * 60 * 1000);
    } else {
        expires.setTime(expires.getTime() + duration * 24 * 60 * 60 * 1000);
    }

    return (document.cookie =
        key +
        "=" +
        encodeURIComponent(value) +
        ";expires=" +
        expires.toUTCString() +
        // Without a path a cookie belongs to the folder of the page that set
        // it: one set on /audit/<token> would be unreadable on /confirm-signup.
        ";path=/");
}

export function deleteCookie(key: string) {
    setCookie(key, "", -1);
}
